/** Hand-drawn SVG navigation icons for the Notebook-Doodle theme. */

export const HomeIcon = ({ size = 18, strokeWidth = 1.5 }) => (
  <svg width={size} height={size} viewBox="0 0 18 18" fill="none" stroke="currentColor"
    strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    <path d="M2.5 8L9 2.5 15.5 8" />
    <path d="M4 7.5V15h3.5v-4h3v4H14V7.5" />
  </svg>
);

export const StoriesIcon = ({ size = 18, strokeWidth = 1.5 }) => (
  <svg width={size} height={size} viewBox="0 0 18 18" fill="none" stroke="currentColor"
    strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 3.5c0-.5.5-1 1-1h4c1 0 2 .8 2 2v11s-1-1.5-2-1.5H3c-.5 0-1-.5-1-1z" />
    <path d="M16 3.5c0-.5-.5-1-1-1h-4c-1 0-2 .8-2 2v11s1-1.5 2-1.5h4c.5 0 1-.5 1-1z" />
  </svg>
);

export const AskPriyaIcon = ({ size = 18, strokeWidth = 1.5 }) => (
  <svg width={size} height={size} viewBox="0 0 18 18" fill="none" stroke="currentColor"
    strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 8.5a6.5 6.5 0 0 1-.7 2.9 6.5 6.5 0 0 1-5.8 3.6 6.5 6.5 0 0 1-2.9-.7L2 16l1.7-4.6a6.5 6.5 0 0 1-.7-2.9A6.5 6.5 0 0 1 6.6 2.7 6.5 6.5 0 0 1 9.5 2h.4A6.5 6.5 0 0 1 16 8.1z" />
    <path d="M7.5 9.5l1.2 1.2 2.8-2.8" />
  </svg>
);

export const MeIcon = ({ size = 18, strokeWidth = 1.5 }) => (
  <svg width={size} height={size} viewBox="0 0 18 18" fill="none" stroke="currentColor"
    strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    <circle cx="9" cy="6" r="3.5" />
    <path d="M3 16c0-3.3 2.7-6 6-6s6 2.7 6 6" />
  </svg>
);
